import React from 'react';
import { ArrowDown } from 'lucide-react';
import { useHeroReveal } from './useHeroReveal';
import './HeroOpening.css';

const SEQUENCE = 'IT, Software & Digital Jobs → Humans + AI Agents → Complete AI Automation';

const HeroConnector = ({ index }) => (
  <span className={`lxt-hero-connector lxt-hero-reveal lxt-hero-connector-${index} text-teal-600`}
    aria-hidden="true" data-testid={`hero-headline-arrow-${index}`}>
    <span className="lxt-hero-arrow-horizontal">→</span>
    <ArrowDown className="lxt-hero-arrow-vertical" size={24} strokeWidth={1.5} />
  </span>
);

export const HeroOpening = () => {
  const { ref, motion, animationEnded } = useHeroReveal();
  return (
    <div className="lxt-hero-opening" ref={ref} data-motion={motion} onAnimationEnd={animationEnded} data-testid="hero-opening">
      <h1 className="hero-headline font-bold text-gray-900 leading-[1.15] tracking-tight whitespace-nowrap overflow-hidden w-full mb-5 lg:mb-10"
        data-testid="hero-question" aria-label={SEQUENCE}>
        <span className="lxt-hero-sequence" aria-hidden="true">
          <span className="lxt-hero-step">
            <span className="lxt-hero-stage lxt-hero-reveal lxt-hero-stage-1" data-testid="hero-headline-stage-1">IT, Software &amp; Digital Jobs</span>
            <HeroConnector index={1} />
          </span>{' '}
          <span className="lxt-hero-step">
            <span className="lxt-hero-stage lxt-hero-reveal lxt-hero-stage-2" data-testid="hero-headline-stage-2">Humans + AI Agents</span>
            <HeroConnector index={2} />
          </span>{' '}
          <em className="lxt-hero-final lxt-hero-stage lxt-hero-reveal lxt-hero-stage-3 not-italic relative inline-block" data-testid="hero-headline-stage-3">
            <span className="lxt-hero-final-text" data-testid="hero-headline-highlight">Complete AI Automation</span>
          </em>
        </span>
      </h1>
      <div data-testid="hero-promise-block">
        <p className="text-sm md:text-xl text-gray-900 font-semibold" data-testid="hero-promise-headline">
          Understand what AI can take over. Build relevant skills. Explore AI careers, blue collar jobs, agriculture and entrepreneurship.
        </p>
        <p className="text-sm text-gray-600 mt-3" data-testid="hero-scenario-caption">A possible future scenario—not a guaranteed outcome.</p>
      </div>
    </div>
  );
};